<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="4")
              div {{ $t('ui.full_time') }}
          tr
            th(style="width: 40px;")
              div.text-right {{ $t('ui.money_line') }}
            th(colspan="2" style="width: 140px;")
              div.text-right {{ $t('ui.hdp') }}
            th(colspan="2" style="width: 140px;")
              div.text-right {{ $t('ui.ou') }}
            th(style="width: 100px;")
              div.text-right {{ $t('ui.oe') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 40px;").text-right
              div(:class="{'up': item.mlh_blink }") {{ item.mlh }}
              div(:class="{'up': item.mla_blink }") {{ item.mla }}
            td(style="width: 40px;").text-muted
              div(:class="{'up': item.fhdp_blink }") {{ item.fhdp }}
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>